<template>
    <div>
        <router-view :url="url" v-on:updateTitle="updateTitle"></router-view>
    </div>
</template>

<script>
export default {
  name: 'Page',
  computed: {
    url: function () {
      return process.env.API_URL + '/' + process.env.API_ENDPOINT + '/admin/pages'
    }
  },
  created: function () {
    this.$emit('activeMenu', '/admin/pages')
    this.$emit('newLink', '/admin/pages/create')
    this.$emit('updateDisable', false)
  },
  methods: {
    updateTitle (val) {
      this.$emit('updateTitle', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/page/Page.vue